// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Gambarino-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Gambarino-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
    font-family: 'Gambarino';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

.hero{
  width: 100%;
  box-sizing: border-box;
  padding: 72px 0 0px; /* laptop-friendly top/bottom breathing room */
}

.hero__inner{
  /* "rail" = width of headline + bottomline */
  --railW: min(90vw);

  /* body copy block width (tuned for laptops) */
  --textW: min(67.5vw);

  /* computed gutter so text blocks can align to rail edges */
  --gutter: calc((100% - var(--railW)) / 2);

  --edgeGap: clamp(26px, 3.2vw, 44px);  /* title↔first + last↔bottomline */
  --paraGap: clamp(22px, 2.8vw, 40px);  /* spacing between body paragraphs */


  /* safe side padding so nothing kisses the viewport on small-ish screens */
  padding: 0 clamp(16px, 3vw, 56px);
  box-sizing: border-box;
  overflow: visible;
}

.hero__title,
.hero__conclusion{
  width: 90vw;
  margin: 0 auto;
  text-align: center;
  white-space: nowrap;
  line-height: 0.98;
  padding-bottom: 0.06em;
  font-weight: 800;
}


/* HEADLINE
.hero__title{
width: 90vw;
margin: 0 auto;
text-align: center;
white-space: nowrap;
line-height: 0.98;
padding-bottom: 0.06em;
font-weight: 800;
margin: 0 auto var(--edgeGap);

}
*/

/* BODY COPY (LEFT-ALIGNED blocks)*/
.hero__lede{
  width: var(--textW);
  margin: 0 auto;                   /*   vertical handled by adjacency rules below */


  margin-left: var(--gutter);             /* snap left edge to rail */

  text-align: left;
  font-weight: 400;
  line-height: 1.55;
  font-size: clamp(18px, 1.45vw, 24px);
  color: rgba(0,0,0,0.86);

  font-family: Gambarino;
}

/* BODY COPY (RIGHT-ALIGNED block) */
.hero__rede{
  width: var(--textW);
  margin: 0 auto;
  margin-right: var(--gutter);             /* snap right edge to rail */

  text-align: right;
  font-weight: 400;
  line-height: 1.55;
  font-size: clamp(18px, 1.45vw, 24px);
  color: rgba(0,0,0,0.86);

  font-family: Gambarino;
}

/* BOTTOMLINE */
.hero__conclusion{
  width: var(--railW);
  margin: 0 auto;  /* spacing handled by the rule above */

  text-align: center;
  font-weight: 800;

  line-height: 0.98;
  padding-bottom: 0.06em;
  overflow: visible;

  font-size: clamp(56px, 5vw, 104px);
  white-space: nowrap;
}

.parafinal{
  width: var(--textW + 10vw);
  margin: 0 auto;                   /*   vertical handled by adjacency rules below */
  text-align: center;
  font-weight: 400;
  line-height: 1.55;
  font-size: 28px;
  color: rgba(0,0,0, 1);

  font-family: Gambarino;
}

/* space after the topline (bigger, so it feels like a “second beat”) */
.hero__title + .hero__lede,
.hero__title + .hero__rede{
  margin-top: var(--edgeGap);
}

/* spacing between the 3 body paragraphs */
/*.hero__title + .hero__lede{ margin-top: 0; }  title already has bottom margin */
.hero__lede + .hero__rede{ margin-top: var(--paraGap); }
.hero__rede + .hero__lede{ margin-top: var(--paraGap); }

/* space before the bottomline (bigger, so it feels like a “second beat”) */
.hero__lede + .hero__conclusion,
.hero__rede + .hero__conclusion{
  margin-top: var(--edgeGap);
}

/* WIPE */

/* container paragraph */
.cw-wipe {
  --p: 0;             /* 0..1 scroll progress (set by JS) */
  --n: 1;             /* total characters (set by JS/React) */
  --dim: rgba(0,0,0,0.26);
  --ink: rgba(0,0,0,0.92);

  position: relative;
}

/* each character wrapper */
.cw-wipe .cw-char {
  position: relative;
  display: inline-block;
  white-space: pre;   /* preserves spaces/newlines in spans */
}

/* base layer (dim) */
.cw-wipe .cw-dim {
  color: var(--dim);
}

/* ink layer sits on top and fades in per character */
.cw-wipe .cw-ink {
  position: absolute;
  inset: 0;
  color: var(--ink);

  /* compute per-char reveal amount */
  /* t = clamp(0, (p*n - i), 1) */
  opacity: clamp(0, calc((var(--p) * var(--n)) - var(--i)), 1);

  /* optional: make it feel slightly smoother */
  transition: opacity 60ms linear;
}

/* accessibility: don't let nested spans mess with selection too much */
.cw-wipe, .cw-wipe * {
  -webkit-font-smoothing: antialiased;
}

/* prevent breaking inside words */
.cw-word {
  white-space: nowrap;
}

/* preserve runs of spaces/newlines as real whitespace */
.cw-space {
  white-space: pre-wrap; /* respects spaces + wraps normally */
}

/* Optional: makes per-char spans behave consistently */
.cw-char {
  display: inline-block;
}


@media (max-width: 768px) {
  .hero {
    padding: 28px 0 56px;
  }

  .hero__inner {
    width: 100%;
    max-width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .hero__title {
    margin: 0 0 22px;
    font-size: clamp(42px, 12vw, 64px);
    line-height: 0.92;
    letter-spacing: -0.05em;
    max-width: 100%;
  }

  .hero__lede,
  .hero__rede {
    margin: 0 0 18px;
    font-size: 16px;
    line-height: 1.5;
    max-width: 100%;
  }

  .hero__conclusion {
    margin: 28px 0 0;
    font-size: clamp(38px, 11vw, 58px);
    line-height: 0.94;
    letter-spacing: -0.05em;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/manifesto.css"],"names":[],"mappings":";AACA;IACI,wBAAwB;IACxB;8DAC+D;IAC/D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB,EAAE,8CAA8C;AACrE;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;;EAElB,8CAA8C;EAC9C,oBAAoB;;EAEpB,2DAA2D;EAC3D,yCAAyC;;EAEzC,mCAAmC,GAAG,kCAAkC;EACxE,mCAAmC,GAAG,oCAAoC;;;EAG1E,0EAA0E;EAC1E,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;;;;;;;;;;;;CAYC;;AAED,mCAAmC;AACnC;EACE,mBAAmB;EACnB,cAAc,oBAAoB,gDAAgD;;;EAGlF,0BAA0B,cAAc,2BAA2B;;EAEnE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B,cAAc,4BAA4B;;EAErE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc,GAAG,sCAAsC;;EAEvD,kBAAkB;EAClB,gBAAgB;;EAEhB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;;EAEjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc,oBAAoB,gDAAgD;EAClF,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;;EAErB,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;;EAEE,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C,iFAAiF;AACjF,2BAA2B,0BAA0B,EAAE;AACvD,2BAA2B,0BAA0B,EAAE;;AAEvD,2EAA2E;AAC3E;;EAEE,0BAA0B;AAC5B;;AAEA,SAAS;;AAET,wBAAwB;AACxB;EACE,MAAM,cAAc,qCAAqC;EACzD,MAAM,cAAc,uCAAuC;EAC3D,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB,IAAI,uCAAuC;AAC7D;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;;EAEjB,mCAAmC;EACnC,+BAA+B;EAC/B,4DAA4D;;EAE5D,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA,uEAAuE;AACvE;EACE,mCAAmC;AACrC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,qBAAqB,EAAE,qCAAqC;AAC9D;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;AACvB;;;AAGA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;EACjB;AACF","sourcesContent":["\n@font-face {\n    font-family: 'Gambarino';\n    src: url('../assets/fonts/Gambarino-Regular.woff2') format('woff2'),\n    url('../assets/fonts/Gambarino-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n.hero{\n  width: 100%;\n  box-sizing: border-box;\n  padding: 72px 0 0px; /* laptop-friendly top/bottom breathing room */\n}\n\n.hero__inner{\n  /* \"rail\" = width of headline + bottomline */\n  --railW: min(90vw);\n\n  /* body copy block width (tuned for laptops) */\n  --textW: min(67.5vw);\n\n  /* computed gutter so text blocks can align to rail edges */\n  --gutter: calc((100% - var(--railW)) / 2);\n\n  --edgeGap: clamp(26px, 3.2vw, 44px);  /* title↔first + last↔bottomline */\n  --paraGap: clamp(22px, 2.8vw, 40px);  /* spacing between body paragraphs */\n\n\n  /* safe side padding so nothing kisses the viewport on small-ish screens */\n  padding: 0 clamp(16px, 3vw, 56px);\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.hero__title,\n.hero__conclusion{\n  width: 90vw;\n  margin: 0 auto;\n  text-align: center;\n  white-space: nowrap;\n  line-height: 0.98;\n  padding-bottom: 0.06em;\n  font-weight: 800;\n}\n\n\n/* HEADLINE\n.hero__title{\nwidth: 90vw;\nmargin: 0 auto;\ntext-align: center;\nwhite-space: nowrap;\nline-height: 0.98;\npadding-bottom: 0.06em;\nfont-weight: 800;\nmargin: 0 auto var(--edgeGap);\n\n}\n*/\n\n/* BODY COPY (LEFT-ALIGNED blocks)*/\n.hero__lede{\n  width: var(--textW);\n  margin: 0 auto;                   /*   vertical handled by adjacency rules below */\n\n\n  margin-left: var(--gutter);             /* snap left edge to rail */\n\n  text-align: left;\n  font-weight: 400;\n  line-height: 1.55;\n  font-size: clamp(18px, 1.45vw, 24px);\n  color: rgba(0,0,0,0.86);\n\n  font-family: Gambarino;\n}\n\n/* BODY COPY (RIGHT-ALIGNED block) */\n.hero__rede{\n  width: var(--textW);\n  margin: 0 auto;\n  margin-right: var(--gutter);             /* snap right edge to rail */\n\n  text-align: right;\n  font-weight: 400;\n  line-height: 1.55;\n  font-size: clamp(18px, 1.45vw, 24px);\n  color: rgba(0,0,0,0.86);\n\n  font-family: Gambarino;\n}\n\n/* BOTTOMLINE */\n.hero__conclusion{\n  width: var(--railW);\n  margin: 0 auto;  /* spacing handled by the rule above */\n\n  text-align: center;\n  font-weight: 800;\n\n  line-height: 0.98;\n  padding-bottom: 0.06em;\n  overflow: visible;\n\n  font-size: clamp(56px, 5vw, 104px);\n  white-space: nowrap;\n}\n\n.parafinal{\n  width: var(--textW + 10vw);\n  margin: 0 auto;                   /*   vertical handled by adjacency rules below */\n  text-align: center;\n  font-weight: 400;\n  line-height: 1.55;\n  font-size: 28px;\n  color: rgba(0,0,0, 1);\n\n  font-family: Gambarino;\n}\n\n/* space after the topline (bigger, so it feels like a “second beat”) */\n.hero__title + .hero__lede,\n.hero__title + .hero__rede{\n  margin-top: var(--edgeGap);\n}\n\n/* spacing between the 3 body paragraphs */\n/*.hero__title + .hero__lede{ margin-top: 0; }  title already has bottom margin */\n.hero__lede + .hero__rede{ margin-top: var(--paraGap); }\n.hero__rede + .hero__lede{ margin-top: var(--paraGap); }\n\n/* space before the bottomline (bigger, so it feels like a “second beat”) */\n.hero__lede + .hero__conclusion,\n.hero__rede + .hero__conclusion{\n  margin-top: var(--edgeGap);\n}\n\n/* WIPE */\n\n/* container paragraph */\n.cw-wipe {\n  --p: 0;             /* 0..1 scroll progress (set by JS) */\n  --n: 1;             /* total characters (set by JS/React) */\n  --dim: rgba(0,0,0,0.26);\n  --ink: rgba(0,0,0,0.92);\n\n  position: relative;\n}\n\n/* each character wrapper */\n.cw-wipe .cw-char {\n  position: relative;\n  display: inline-block;\n  white-space: pre;   /* preserves spaces/newlines in spans */\n}\n\n/* base layer (dim) */\n.cw-wipe .cw-dim {\n  color: var(--dim);\n}\n\n/* ink layer sits on top and fades in per character */\n.cw-wipe .cw-ink {\n  position: absolute;\n  inset: 0;\n  color: var(--ink);\n\n  /* compute per-char reveal amount */\n  /* t = clamp(0, (p*n - i), 1) */\n  opacity: clamp(0, calc((var(--p) * var(--n)) - var(--i)), 1);\n\n  /* optional: make it feel slightly smoother */\n  transition: opacity 60ms linear;\n}\n\n/* accessibility: don't let nested spans mess with selection too much */\n.cw-wipe, .cw-wipe * {\n  -webkit-font-smoothing: antialiased;\n}\n\n/* prevent breaking inside words */\n.cw-word {\n  white-space: nowrap;\n}\n\n/* preserve runs of spaces/newlines as real whitespace */\n.cw-space {\n  white-space: pre-wrap; /* respects spaces + wraps normally */\n}\n\n/* Optional: makes per-char spans behave consistently */\n.cw-char {\n  display: inline-block;\n}\n\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 28px 0 56px;\n  }\n\n  .hero__inner {\n    width: 100%;\n    max-width: 100%;\n    padding: 0 20px;\n    box-sizing: border-box;\n  }\n\n  .hero__title {\n    margin: 0 0 22px;\n    font-size: clamp(42px, 12vw, 64px);\n    line-height: 0.92;\n    letter-spacing: -0.05em;\n    max-width: 100%;\n  }\n\n  .hero__lede,\n  .hero__rede {\n    margin: 0 0 18px;\n    font-size: 16px;\n    line-height: 1.5;\n    max-width: 100%;\n  }\n\n  .hero__conclusion {\n    margin: 28px 0 0;\n    font-size: clamp(38px, 11vw, 58px);\n    line-height: 0.94;\n    letter-spacing: -0.05em;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
